import { SubscriptionAvailabilityModel } from './../models/subscriptionavailabilityrestriction.model';
import { SubscriptionService } from './../../sharedvehiclegroupsubscription/models/sharedvehiclegroupsubscription.service';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel, WeGoAuthorizedLink, Permission, PermissionType, Entity } from '../../shared/config';


@Component({
  selector: 'wego-subscriptionavailabilityrestriction-list',
  template: require('../views/subscriptionavailabilityrestriction-list.component.html'),
  providers: [SubscriptionService],
})

export class SubscriptionAvailabilityListComponent implements OnInit {
  DataListModel: DataListModel;
  subscriptionAvailabilityModelList: SubscriptionAvailabilityModel[];
  apiErrorMsg: string;
  isLoading: boolean;

  private breadCrumbList: string;
  private module: string;
  private subscriptionName: string;
  errorMessage: string;
  private urlDefaultPage: string;
  apiResponse: IAPIResponse;
  contractTypeGroupList: any;
  alertMsg: string;
  private popupMsg: string;
  private popupTitle: string;
  public sharedVehicleGroupSubscriptionHashId: string;
  urlSubscriptionAvaibilityUpdate: string;
  urlSubscriptionAvaibilityADD: string;
  urlSubscriptionList: string;
  subscriptionList: string;
  sharedVehicleGroupHashId: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteSubscriptionAvailabilityHashId: string;
  sharedvehicleGroup: string;
  urlSVGList: string;
  addSVGSubscriptionRestrictionLink: any;

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('childModal') public childModal: any;

  constructor(private subscriptionService: SubscriptionService,
    private translate: TranslateService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router) {
  }
  get isAnyChecked(): boolean {
    if (this.subscriptionAvailabilityModelList) {
      let isCheck = this.subscriptionAvailabilityModelList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.subscriptionAvailabilityModelList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }
  ngOnInit() {
    this.module = this.translate.instant('LblSubscriptionAvailabilityRestriction', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.subscriptionList = this.translate.instant('LblListPage', this.translate.instant('LblSubscription'));
    this.sharedvehicleGroup = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSubscriptionList = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTION_LIST);
    this.urlSubscriptionAvaibilityUpdate = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE);
    this.urlSubscriptionAvaibilityADD = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_ADD);
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["startDayName", "endDayName"];

    this.activeRoute
      .params
      .subscribe(params => {
        let sharedVehicleGroupSubscriptionHashId = params['id'] || '';
        this.sharedVehicleGroupSubscriptionHashId = sharedVehicleGroupSubscriptionHashId;
        if (sharedVehicleGroupSubscriptionHashId != '') {
          this.sharedVehicleGroupSubscriptionHashId = sharedVehicleGroupSubscriptionHashId;
          this.GetSubscriptionName();
          this.GetSubscriptionAvailabilityRestrictionList();
          // this.addSVGSubscriptionRestrictionLink = new WeGoAuthorizedLink(this.urlSubscriptionAvaibilityUpdate + '/'+sharedVehicleGroupSubscriptionHashId+'/'+ this.sharedVehicleGroupHashId ,
          // Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', Entity.SVG, this.sharedVehicleGroupHashId);
        }
      });
  }

  get isDeleteAccess(): boolean {
    if (this.subscriptionAvailabilityModelList) {
      return this.subscriptionAvailabilityModelList.some(x => x.isDeletable);
    }
    else { return false; }
  }

  public GetSubscriptionName() {
    this.subscriptionService.GetSubscriptionBasicDetail(this.sharedVehicleGroupSubscriptionHashId)
      .subscribe(
      res => {
        if (res.data)
          this.subscriptionName = res.data.entityName;
          this.sharedVehicleGroupHashId = res.data.entityHashId;
          this.addSVGSubscriptionRestrictionLink = new WeGoAuthorizedLink(this.urlSubscriptionAvaibilityADD + '/' + this.sharedVehicleGroupSubscriptionHashId + '/' + this.sharedVehicleGroupHashId,
          Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', Entity.SVG, this.sharedVehicleGroupHashId);
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public GetSubscriptionAvailabilityRestrictionList() {
    this.isLoading = true;
    this.subscriptionService.GetSubscriptionAvailability(this.sharedVehicleGroupSubscriptionHashId, this.DataListModel)
      .subscribe(
      res => {
        this.subscriptionAvailabilityModelList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
        this.subscriptionAvailabilityModelList = [];
        this.DataListModel.infoMessage = error;
      });
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.subscriptionService.ExportAvailabilityRestrriction(this.sharedVehicleGroupSubscriptionHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "AvailabilityRestriction" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }
  public OnParentCheck(isChecked: boolean) {
    this.subscriptionAvailabilityModelList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }
  public ShowChildModal(availbilityHashId?: string): void {
    if (availbilityHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteSubscriptionAvailabilityHashId = availbilityHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.childModal.show();
  }

  public HideChildModal(): void {
    this.deleteSubscriptionAvailabilityHashId = "";
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    let deletedAvailabilityist: any[];
    if (this.isMultipleDelete)
      deletedAvailabilityist = this.subscriptionAvailabilityModelList.filter(x => x.isChecked).map(x => x.subscriptionAvailabiltiyHashId);
    else
      deletedAvailabilityist.push(this.deleteSubscriptionAvailabilityHashId);

    this.DeleteRestriction(deletedAvailabilityist);
    this.childModal.hide();
  }
  public DeleteRestriction(deletedAvailabilityist: string[]) {
    this.isLoading = true;
    this.subscriptionService.DeleteAvailabilityRestriction(deletedAvailabilityist)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetSubscriptionAvailabilityRestrictionList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSubscriptionAvailabilityRestrictionList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSubscriptionAvailabilityRestrictionList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetSubscriptionAvailabilityRestrictionList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSubscriptionAvailabilityRestrictionList();
  };
  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/subscriptionavailabilityrestriction/components/subscriptionavailabilityrestriction-list.component.ts